import script from "./NoteActionsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteActionsButton.vue?vue&type=script&setup=true&lang=js"

import "./NoteActionsButton.vue?vue&type=style&index=0&id=5ec37e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec37e28"]])

export default __exports__